export const ListIcon = (props: React.SVGProps<SVGSVGElement>) => {
    return (
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                d="M16 4.00073C16 3.72419 15.7758 3.5 15.4993 3.5H5.50075C5.2242 3.5 5 3.72418 5 4.00073C5 4.27648 5.22354 4.5 5.49929 4.5H15.5007C15.7765 4.5 16 4.27647 16 4.00073Z"
                fill="currentColor"
            />
            <path
                d="M2 4C2 4.55231 1.55231 5 1 5C0.447687 5 0 4.55231 0 4C0 3.44769 0.447687 3 1 3C1.55231 3 2 3.44769 2 4Z"
                fill="currentColor"
            />
            <path
                d="M16 8.00073C16 7.72419 15.7758 7.5 15.4993 7.5H5.50075C5.2242 7.5 5 7.72418 5 8.00073C5 8.27648 5.22354 8.5 5.49929 8.5H15.5007C15.7765 8.5 16 8.27647 16 8.00073Z"
                fill="currentColor"
            />
            <path
                d="M2 8C2 8.55231 1.55231 9 1 9C0.447687 9 0 8.55231 0 8C0 7.44769 0.447687 7 1 7C1.55231 7 2 7.44769 2 8Z"
                fill="currentColor"
            />
            <path
                d="M16 12.0007C16 11.7242 15.7758 11.5 15.4993 11.5H5.50075C5.2242 11.5 5 11.7242 5 12.0007C5 12.2765 5.22354 12.5 5.49929 12.5H15.5007C15.7765 12.5 16 12.2765 16 12.0007Z"
                fill="currentColor"
            />
            <path
                d="M2 12C2 12.5523 1.55231 13 1 13C0.447687 13 0 12.5523 0 12C0 11.4477 0.447687 11 1 11C1.55231 11 2 11.4477 2 12Z"
                fill="currentColor"
            />
        </svg>
    );
};
